import type { UserPreferencesNotificationsFooterProps } from "./user-preferences-notifications-footer.type";

import { Button, Flex } from "antd";
import { useTranslation } from "react-i18next";

import "./user-preferences-notifications-footer.style.less";

export const UserPreferencesNotificationsFooter = ({
  isPending,
  isDirty,
  onSave,
  onCancel,
}: UserPreferencesNotificationsFooterProps) => {
  const { t } = useTranslation();

  return (
    <Flex
      gap={8}
      justify="end"
      className="user-preferences-notifications-footer"
    >
      <Button onClick={onCancel} disabled={!isDirty || isPending}>
        {t("global:cancel")}
      </Button>

      <Button
        loading={isPending}
        type="primary"
        onClick={onSave}
        disabled={!isDirty}
      >
        {t("global:save")}
      </Button>
    </Flex>
  );
};
